export enum STORAGE_KEY {
  SEARCH_HISTORY = 'searchHistory',
  EASY_CERTIFICATION = 'easyCertification',
  KOSAF_PROCESS = 'kosafProcess',
  JEJU_YOUTHDREAM = 'jejuYouthdream',
  NICE_FORM_VALUES = 'niceFormValues',
  LOGOUT_TOAST = 'logoutToast',
  POLICY_FILTER_LANDING = 'policyFilterLanding',
  POLICY_FILTER_LANDING_FROM = 'policyFilterFrom',
  POLICY_FILTER = 'policyFilter',
  HOMETOWN_NEWS_DETAIL_BOTTOM_DRAWER_PATH = 'hometownNewsDetailBottomDrawerPath',
  IS_NOT_SEE_AGAIN_VOUCHER_RECOMMEND = 'isNotSeeAgainVoucherRecommend',
  VOUCHER_MAIN_SCROLL = 'voucherMainScroll',
  VOUCHER_DETAIL_SCROLL = 'voucherDetailScroll',
  MY_INFO_PROFILE_SCRAP_ACTIVE_TAB = 'myInfoProfileScrapActiveTab',

  /** 회원 가입시 어떤 사용자가 추천했는지를 구분할 수 있는 코드 */
  MEMBER_CODE = 'memberCode',

  /** 웰퍼 신청 프로세스 중에 임시로 저장해 놓는 정책 분야 태그들 */
  WELLPER_APPLY_POLICY_TEMP_VALUES = 'wellperApplyPolicyTempValues',

  //* DLP 서울특별시
  DLP_SEOUL_AUTH_POLICY_ID_IDX = 'dlpSeoulAuthPolicyIdIdx',
  DLP_SEOUL_AUTH_DETAIL_APPLY_TYPE = 'dlpSeoulAuthDetailApplyType',
  DLP_SEOUL_AUTH_STEP = 'dlpSeoulAuthStep',
  DLP_SEOUL_AUTH_VERIFICATION_INFO = 'dlpSeoulAuthVerificationInfo',
  DLP_SEOUL_AUTH_SESSION_ID = 'dlpSeoulAuthSessionId',
  DLP_SEOUL_AUTH_USER_ID = 'dlpSeoulAuthUserId',
  DLP_SEOUL_AUTH_USER_ID_MASKING = 'dlpSeoulAuthUserIdMasking',
  DLP_SEOUL_AUTH_REDIRECT = 'dlpSeoulAuthRedirect',
  DLP_SEOUL_LOGIN_SESSION_ID = 'dlpSeoulLoginSessionId',
  DLP_SEOUL_ISLT_YOUTH_SPRT_FORM = 'dlpSeoulIsltYouthSprtForm',

  //* DLP 경기도
  DLP_GYEONGGI_AUTH_STEP = 'dlpGyeonggiAuthStep',
  DLP_GYEONGGI_AUTH_LOGIN_REDIRECT = 'dlpGyeonggiAuthLoginRedirect',
  DLP_GYEONGGI_AUTH_VERIFICATION_INFO = 'dlpGyeonggiAuthVerificationInfo',
  DLP_GYEONGGI_AUTH_SESSION_ID = 'dlpGyeonggiAuthSessionId',
  DLP_GYEONGGI_LOGIN_SESSION_ID = 'dlpGyeonggiLoginSessionId',

  //* 럭키볼 관련
  OPEN_ONCE_LUCKY_BALL_MODAL_BY_HOME = 'openOnceLuckyBallModalByHome',
  SHOW_ONCE_GET_LUCKY_BALL_TOAST_BY_MY_LUCKY_BALL = 'showOnceGetLuckyBallToastByMyLuckyBall',

  /** history 관련 정보 */
  HISTORY = 'history',
  HISTORY_EXPIRE = 'historyExpire',
  HISTORY_INDEX = 'historyIndex',
  REPLACE_MARK = 'replaceMark',
}

export namespace STORAGE_TYPE {
  export type HISTORY = [number, string][];
}
